export const LOGO_URL =
  "https://static.prod-images.emergentagent.com/jobs/6bf21dc7-caab-410d-805a-c678886d7aff/images/bd1796365fcde0d274982f87c3974cb81bcd5a0d1ced2ce918553f2e5a0ba3c3.png";

export const HERO_CANADA =
  "https://images.unsplash.com/photo-1567647753830-de3fe7ce9f28?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export const HERO_ILLUSTRATION =
  "https://static.prod-images.emergentagent.com/jobs/6bf21dc7-caab-410d-805a-c678886d7aff/images/f3a95a254a02e7c44c6e6c97678cc4c4341b5ecf1d82ac4b058b5feb925cb4d6.png";

export const CANADA_IMAGES = [
  "https://images.unsplash.com/photo-1516293635722-a0ae2709d570?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  "https://images.unsplash.com/photo-1506104489822-562ca25152fe?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  "https://images.unsplash.com/photo-1587381419916-78fc843a36f8?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
];
